import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { addGateway } from "../redux/slices/gatewaysSlice";
import { addNewGateway } from "../services/gatewayService";
import { getTranslation } from "../translations/getTranslations";
import { useNotification } from "../notifications/Notifications";

const AddGateway = () => {
  const [serialNumber, setSerialNumber] = useState("");
  const dispatch = useDispatch();
  const notify = useNotification();
  const language = useSelector(state => state.settings.language);
  const translation = useCallback(key => getTranslation("addGateway", key, language), [language]);

  const handleSerialNumberChange = e => {
    setSerialNumber(e.target.value);
  };

  const handleAddGateway = async () => {
    if (serialNumber.trim()) {
      try {
        const addedGateway = await addNewGateway(serialNumber);
        dispatch(addGateway(addedGateway));
        notify("success", translation("_addGatewaySuccess"));
        setSerialNumber("");
      } catch (error) {
        notify("error", translation("_addGatewayError"));
      }
    } else {
      notify("warn", translation("_fillFieldsAlert"));
    }
  };

  return (
    <div className={`flex h-full flex-col items-center overflow-hidden bg-backgroundPrimary p-10`}>
      <div
        className={`w-[90%] space-y-6 rounded bg-inputBackground p-6 text-textPrimary shadow-lg lg:w-[70%] xl:w-[50%]`}
      >
        <h2 className={`text-2xl font-semibold text-textPrimary`}>{translation("_addGatewayTitle")}</h2>
        <div className="flex w-full flex-col items-center gap-4">
          <label className={`text-lg font-medium text-textPrimary`}>{translation("_serialNumber")}</label>
          <input
            className={`h-[45px] w-full rounded border border-inputBorder bg-inputBackground p-2 text-textPrimary hover:bg-inputHover focus:outline-none`}
            type="text"
            name="serialNumber"
            placeholder={translation("_serialNumberPlaceholder")}
            value={serialNumber}
            onChange={handleSerialNumberChange}
          />
          <button
            className={`flex h-[45px] items-center justify-center rounded bg-buttonSubmit p-2 text-buttonText hover:bg-buttonSubmitHover`}
            onClick={handleAddGateway}
          >
            <FontAwesomeIcon icon={faPlus} className="mr-2" />
            {translation("_addGateway")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGateway;
